<template>
  <div id="body" class="theme-cyan">
    <!-- Main Content -->
    <div class="body_area after_bg sm">
      <div class="block-header">
        <div class="container">
          <div class="row clearfix">
            <div class="col-lg-6 col-md-12">
              <!-- <h1 class="mb-1 mt-1">Developer Page</h1> -->
            </div>
          </div>
          <div class="bh_divider"></div>
        </div>
      </div>
      <div class="body_area">
        <div class="container">
          <!-- Basic Table -->

          <router-view />
          <footer-view />
          <!-- #END# Hover Rows -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FooterView from "@/components/common/FooterView.vue";
// import DevMenu from '@/components/dev/DevMenu.vue'

export default {
  components: {
    FooterView: FooterView,
    // "DevMenu": DevMenu,
  },
  methods: {
    changeStatus() {
      console.log("here");
    },
    checkingMenus(num) {
      this.homeMenu = false;
      this.authMenu = false;
      this.trigMenu = false;
      this.actMenu = false;

      if (num == 0) {
        this.homeMenu = !this.homeMenu;
        this.heading = "Home";
        this.$store.state.devStore.urlType = "home";
      } else if (num == 1) {
        this.authMenu = !this.authMenu;
        this.heading = "Authentication";
        this.$store.state.devStore.urlType = "auths";
      } else if (num == 2) {
        this.trigMenu = !this.trigMenu;
        this.heading = "Trigger";
        this.$store.state.devStore.urlType = "triggers";
      } else if (num == 3) {
        this.actMenu = !this.actMenu;
        this.heading = "Actions";
        this.$store.state.devStore.urlType = "actions";
      }
    },
    iWantThisApp(id) {
      this.$router.push({ name: "DevMain", params: { appId: id } });
    },

    //    myEventHandler(){
    //         var size = window.innerWidth;
    //         // console.log("dev main",size)
    //         if(size < 700){
    //             document.getElementsByClassName('topBodyArea')[0].classList.remove('h_menu')
    //             document.getElementsByClassName('topBodyArea')[0].classList.add('ls-closed')
    //         } else {
    //                 document.getElementsByClassName('topBodyArea')[0].classList.add('h_menu')
    //             document.getElementsByClassName('topBodyArea')[0].classList.remove('ls-closed')
    //         }

    //     }
  },

  data() {
    return {
      heading: "Home",

      homeMenu: true,
      authMenu: false,
      trigMenu: false,
      actMenu: false,
    };
  },
  watch: {},
  computed: {},

  mounted() {},
  created() {
    // window.addEventListener("resize", this.myEventHandler);

    console.log("해당 url ");
    console.log(window.location.pathname);
    var url = window.location.pathname;
    if (url.includes("authentication")) {
      console.log("authentication 접근한 url ");
      this.checkingMenus(1);
    } else if (url.includes("trigger")) {
      console.log("trigger 접근한 url ");
      this.checkingMenus(2);
    } else if (url.includes("action")) {
      console.log("action 접근한 url ");
      this.checkingMenus(3);
    } else {
      console.log("home 접근한 url ");
      this.checkingMenus(0);
    }
  },
};
</script>
